import { BarChartByProps } from '../config';
import { useCallback } from 'react';
import BarChartScenario from '../bar-chart-scenario/BarChartScenario';
import { getSelfTestName } from '@customer/shared/utils/translationHelpers';
import { useTranslation } from 'react-i18next';
import { ScenarioDataSetLabelV2, ScenarioQueryParams } from '@customer/store/apis/scenariosApi';
import { GetTooltipTitle } from '../utils';
import { useAppDispatch, useAppSelector } from '@customer/store/hooks';
import { CustomBarChartLabel, OnCategorySelect } from '../bar-select/BarSelectPlugin';
import { saveFilters, setFaultCategories, setFaults } from '@customer/store/slices/filtersSlice';
import { SelfTestOption, selfTests } from '@customer/config';
// import { isEnumValue } from "@customer/shared/utils/typeHelpers";
// import { FaultLevel } from "@customer/store/slices/globalSlice";
// import { FilterGroup } from "@customer/filters/types";

// TODO: Re-enable the commented code after the UX for bar segment selection has been improved.

export const BarChartByFaultTestName = <T extends ScenarioQueryParams>(props: BarChartByProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const siteId = useAppSelector(state => state.auth.siteId);

  const getFaultTestNameLabel = useCallback(
    (label: ScenarioDataSetLabelV2) => {
      return getSelfTestName(t, label.id);
    },
    [t],
  );

  const getTooltipTitle = useCallback<GetTooltipTitle>(
    (_, categoryLabelKey) => {
      return getSelfTestName(t, Number(categoryLabelKey));
    },
    [t],
  );

  const onCategorySelect = useCallback<OnCategorySelect>(
    ({ id: faultId }: CustomBarChartLabel): void => {
      if (siteId) {
        const fault: SelfTestOption | undefined = selfTests.find(
          (fault: SelfTestOption) => fault[0] === faultId,
        );

        if (fault) {
          const [faultId, , faultCategoryId] = fault;
          dispatch(setFaultCategories([faultCategoryId]));
          dispatch(setFaults([faultId]));
          dispatch(saveFilters(siteId));
        }
      }
    },
    [dispatch, siteId],
  );

  // const onBarSelect = useCallback<OnBarSelect>(({ id: faultId }: CustomBarChartLabel, datasetId: string): void => {
  //   if (siteId) {
  //     const fault: SelfTestOption | undefined = selfTests.find((fault: SelfTestOption) => fault[0] === faultId);

  //     if (fault) {
  //       const [faultId, , faultCategoryId] = fault;
  //       dispatch(setFaultCategories([faultCategoryId]));
  //       dispatch(setFaults([faultId]));

  //       // Optionally filter by fault level if the filter group allows it.
  //       if (props.filterGroup === FilterGroup.AssetSelfTest && isEnumValue(datasetId, FaultLevel)) {
  //         dispatch(setFaultLevels([datasetId]));
  //       }

  //       dispatch(saveFilters(siteId));
  //     }
  //   }
  // }, [dispatch, siteId, props.filterGroup]);

  return (
    <BarChartScenario<T>
      {...props}
      getCategoryLabel={getFaultTestNameLabel}
      getTooltipTitle={getTooltipTitle}
      onCategorySelect={onCategorySelect}
      // Temporarily use the same function for onBarSelect until the UX is improved.
      onBarSelect={onCategorySelect}
    />
  );
};

export default BarChartByFaultTestName;
